// This file is generated by a script and should not be modified directly.
const markdown: string =
  "Code RNCP du périmètre de recherche\n\nLe RNCP correspond au Répertoire national des certifications professionnelles de [France Compétences](https://www.francecompetences.fr/reguler-le-marche/certification-professionnelle/)\n"
export default markdown
